var data_B = {
    // 内部流程容器标识(从不渲染到 UI, 不参与比较), 使用 ASCII 占位以消除 CJK
    name: 'flowB',
    nodeList: [],
    lineList: []
}

export function getDataB() {
    return data_B
}



// WEBPACK FOOTER //
// ./src/components/ef/data_B.js